import React, {useRef, useEffect} from 'react';
import Cards from './Cards';
import gsap, {Power2} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import {Container, Row, Col, Card, Button} from 'react-bootstrap';
function Project() {
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);
  gsap.registerPlugin(ScrollTrigger);
  const card1 = [
    {
      title: 'hello world',
      description:
        "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      title: 'hello world',
      description:
        "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      title: 'hello world',
      description:
        "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
  ];
  // let pg=useRef(null);
  // var n=ReactDOM.findDOMNode(pg);
  // useEffect((n)=>{
  //      n=ReactDOM.findDOMNode(pg);
  //     console.log(n.offsetTop);
  //    // console.log(pg.current.offsetTop;)
  // },[n])

  const card2 = [
    {
      title: 'WhatsApp Clone',
      description: `Online Messaging Platform where one can send message to others
        in blazing fast speed\n`,
    },
    {
      title: 'hello world',
      description:
        "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      title: 'hello world',
      description:
        "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
  ];

  useEffect(() => {
    if (width > 476) {
      const z1 = gsap.timeline();
      z1.from('.cd', {
        duration: 0.4,
        stagger: 0.15,
        ease: Power2.easeInOut,
        y: 100,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: '.project-section',
          end: 'top+=10% top',
          scrub: true,
        },
      })
        .from('.basic-heading', {
          ease: Power2.easeInOut,
          scrollTrigger: {
            trigger: 'project-section',
            start: 'center-=10% center',
            end: 'center-=5% center',
            scrub: true,
          },
          y: 50,
        })
        .from('.project-heading::after', {
          ease: Power2.easeInOut,
          scrollTrigger: {
            trigger: 'project-section',
            start: 'center-=10% center',
            end: 'center-=5% center',
            scrub: true,
          },
          width: 0,
        });
    }
  });

  return (
    <div className="project-section" id="project">
      <Container className="project ">
        <div className="project-heading text-left">
          <h3 className="basic-heading">Projects !</h3>
        </div>
        <Row>
          <Col lg={4}>
            <div className="cd">
              <Cards
                className="cd"
                title="Examination Management System"
                description={`Examination portal for students and teachers.\nRole based authentication for different users.\nTeachers can create, delete, schedule, assign and see results of tests.\nStudents can attempt, pause, submit and see the result analysis. 60% faster than a typical examination portal.`}
                one="React"
                two="Nodejs"
                three="Antd"
                link="https://github.com/alii13/examination-management-system"
                demo="https://ems-in.herokuapp.com/"
              />
            </div>
          </Col>

          <Col lg={4}>
            <div className="cd">
              <Cards
                className="cd"
                title="Docs Go"
                description={`A modern file transfer web application using p2p connection b/w users.\nTransfer files upto 8gb in a room.\nCreates real time connection b/w users using websocket and socket.io.\nUsers can join room through unique room URL.`}
                one="React"
                two="Socket.io"
                three="Nodejs"
                link="https://github.com/alii13/docsgo"
                demo="https://docsgo.herokuapp.com/"
              />
            </div>
          </Col>

          <Col lg={4}>
            <div className="cd">
              <Cards
                className="cd"
                title="React Captchaa package"
                description={`A lightweight reusable captcha package for react.\nCustomizable captchas characterset for validation.\nPrevents copying by showing captcha text on canvas.\nSupport additional Icons, native click events for customization.`}
                one="React"
                two="npm"
                three="Captcha"
                link="https://github.com/alii13/react-captchaa"
                demo="https://alii13.github.io/react-captchaa/"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <div className="cd">
              <Cards
                className="cd"
                title="Cheatmcqs"
                description={`This is a tool for downloading MCQs from sanfoundry (an MCQ questions bank website with content over 10k+ pages )\nTool for downloading MCQs from engineering question bank site. Download content of 5k+ pages in pdf/txt format on a single click.\nUsed by 500+ people from all over the world and seen by 1.5k+ people on youtube.`}
                one="HTML5"
                two="CSS"
                three="Javascript"
                link=""
                demo="https://www.cheatmcqs.in"
              />
            </div>
          </Col>
          <Col lg={4}>
            <div className="cd">
              <Cards
                className="cd"
                title="WhatsApp Clone"
                description={`Real-time chatting web app using firebase firestore.\nSupport separate chatting groups.\nSupport lastseen, embedded link, emojis, datewise chats. Implemented role based authentication for tracking messages `}
                one="React"
                two="Firebase"
                three="Firestore"
                link="https://github.com/alii13/whatsapp-clone"
                demo="https://whatsapp-73989.web.app/"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Project;
